import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { DEFAULT_ROWS_PER_PAGE } from '../../utils/paginationUtils';

export const fetchUsers = createAsyncThunk('users/list', (args = {}, { getState }) => {
  const state = getState();

  const { search, page, limit } = {
    search: args.search ?? state.users.options.search ?? 0,
    page: args.page ?? state.users.options.page ?? 1,
    limit: args.limit ?? state.users.options.limit ?? 10,
  };
  return api
    .get(
      `/users?search=${search ? encodeURIComponent(search) : ''}
    &page=${encodeURIComponent(page)}&limit=${encodeURIComponent(limit)}`
    )
    .then((response) => response.data);
});

export const createUser = createAsyncThunk('users/create', (args, { dispatch }) => {
  const { email, first_name, last_name, role, status, password, verify_password } = args;
  return api
    .post('/users', { email, first_name, last_name, role, status, password, verify_password })
    .then(() => dispatch(fetchUsers()));
});

export const updateUser = createAsyncThunk('users/update', (args, { dispatch }) => {
  const { user_id, email, first_name, last_name, role, status, password, verify_password } = args;
  return api
    .put(`/users/${user_id}`, { email, first_name, last_name, role, status, password, verify_password })
    .then(() => dispatch(fetchUsers()));
});

const initialState = {
  data: [],
  totalItems: 0,
  error: null,
  isLoading: false,
  options: {
    search: '',
    page: 1,
    limit: DEFAULT_ROWS_PER_PAGE,
  },
};

const usersSlice = createSlice({
  name: 'users',
  initialState: initialState,
  reducers: {
    setFilters: (state, action) => {
      const { search, page, limit } = action.payload;
      if (search !== undefined) state.options.search = search;
      if (page !== undefined) state.options.page = page;
      if (limit !== undefined) state.options.limit = limit;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.data = [];
    });

    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
      state.totalItems = action.payload.totalItems;
      state.options.page = action.payload.currentPage;
    });

    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(createUser.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(createUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(createUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updateUser.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilters } = usersSlice.actions;
export default usersSlice.reducer;
